/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Rizwan Shaikh",
  title: "Hi, I'm Rizwan",
  subTitle: emoji(
    "A Tech enthusiast having an experience of building Web applications. Eager to explore different technologies and use them to solve real world problems efficiently while leveraging my potential."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1lcbkW-O7K2dYw-QLGAqRmgEKJV3lnrap/view",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Rizwan-S",
  linkedin: "https://www.linkedin.com/in/mohd-rizwan-shaikh-a533531b3/",
  gmail: "mohdrizwan.shaikh2112@gmail.com",
  //instagram: "https://www.instagram.com/_rizwan.s/",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "THE KIND OF DEVELOPER THAT WANTS TO EXPORE EVERY TECH STACK",
  skills: [],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "C",
      src: "https://img.icons8.com/color/96/000000/c-programming.png"
    },
    {
      skillName: "C++",
      src: "https://img.icons8.com/color/96/000000/c-plus-plus-logo.png"
    },
    {
      skillName: "Python",
      src: "https://img.icons8.com/color/96/000000/python.png"
    },
    {
      skillName: "Java",
      src: "https://img.icons8.com/color/96/000000/java-coffee-cup-logo.png"
    },
    {
      skillName: "HTML",
      src: "https://img.icons8.com/color/96/000000/html-5--v1.png"
    },
    {
      skillName: "CSS",
      src: "https://img.icons8.com/color/96/000000/css3.png"
    },
    {
      skillName: "Javascript",
      src: "https://img.icons8.com/color/96/000000/javascript.png"
    },
    {
      skillName: "MongoDB",
      src: "https://img.icons8.com/color/96/000000/mongodb.png"
    },
    {
      skillName: "ReactJS",
      src: "https://img.icons8.com/plasticine/96/000000/react.png"
    },
    {
      skillName: "Bootstrap",
      src: "https://img.icons8.com/color/96/000000/bootstrap.png"
    },
    {
      skillName: "NodeJS",
      src: "https://img.icons8.com/color/96/000000/nodejs.png"
    },
    {
      skillName: "Git",
      src: "https://img.icons8.com/color/96/000000/git.png"
    },
    {
      skillName: "Github",
      src: "https://img.icons8.com/ios-glyphs/96/000000/github.png"
    },
    {
      skillName: "MATLAB",
      src: "https://img.icons8.com/fluency/96/000000/matlab.png"
    },
    {
      skillName: "LaTeX",
      src: "https://img.icons8.com/color/96/000000/latex.png"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName:
        "International Institute of Information Technology, Bangalore",
      logo: require("./assets/images/iiitb_logo.jpg"),
      subHeader:
        "Integrated M.Tech in Electronics and Communication Engineering",
      duration: "August 2019 - July 2024"
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Smt. Maherbanu Junior College",
      logo: require("./assets/images/logosmt.png"),
      subHeader: "Senior Secondary School",
      duration: "July 2017 - April 2019",
      desc:
        "Secured 88% in HSC Examination conducted by Maharashtra State Board."
      //descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    },
    {
      schoolName: "Holy Cross Convent High School, Akola",
      logo: require("./assets/images/school.jpeg"),
      subHeader: "Secondary School",
      duration: "April 2017",
      desc:
        "Secured 93.6% in SSC Examination conducted by Maharashtra State Board."
      //descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section

  experience: [
    {
      role: "Research Intern",
      company: "International Institute of Information Technology, Bangalore",
      companylogo: require("./assets/images/iiitb_logo.jpg"),
      date: "May 2021 - September 2021",
      desc:
        "Research intern in the field of 'Human Computer Interaction' under the supervision of Prof. Preeti Mudliar [https://www.iiitb.ac.in/faculty/preeti-mudliar]",
      descBullets: [
        "Did qualitative research on the topic 'Privacy and Surveillance in Online Learning Environments'.",
        "Read literature on relevant topics, conducted interviews and coded the data.",
        "Also involved with segregating, classifying and analyzing the coded data."
      ],
      footerLink: []
    },
    {
      role: "Mentor at LGMSoC",
      company: "Let's Grow More Summer of Code",
      companylogo: require("./assets/images/LGMSOC.png"),
      date: "June 2021 - August 2021",
      desc:
        "Lets Grow More - Summer Of Code is an online 2-month long open-source program, designed to encourage student participation in open source software development under the guidance of mentors from the open-source community.",
      descBullets: [
        "Selected as a mentor for MAKESMATHEASY and AWESOME JAVASCRIPT PROJECTS",
        "Actively helped beginners to start with their first issues and made them familiar with the workflow of Github, and with the front-end technologies",
        "Raised issues, mentored and reviewed pull requests and issues of participants and helped them improve the quality of code"
      ],
      footerLink: [
        {
          name: "Certificate of Mentorship",
          url:
            "https://drive.google.com/file/d/19aACHmvJWkN27rzTS7QfXFaceuIwZXxx/view?usp=sharing"
        },
        {
          name: "Certificate ",
          url:
            "https://drive.google.com/file/d/1nt4MAzmxPogwPCuIkRo1DY22pRGizjW_/view?usp=sharing"
        }
      ]
    }
    // {
    //   role: "Software Engineer",
    //   company: "Facebook",
    //   companylogo: require("./assets/images/facebookLogo.png"),
    //   date: "June 2018 – Present",
    //   desc:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //   descBullets: [
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
    //   ]
    // },
    // {
    //   role: "Front-End Developer",
    //   company: "Quora",
    //   companylogo: require("./assets/images/quoraLogo.png"),
    //   date: "May 2017 – May 2018",
    //   desc:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Recipient of LiFT scholarship 2021",
      subtitle:
        "The Linux Foundation hosts The Linux Foundation Training (LiFT) Scholarship Program to provide opportunities to up-and-coming developers and sysadmins who show promise for helping shape the future of Linux and open source software. I'm selected as one of the 500 recipients worldwide in 2021.",
      image: require("./assets/images/LiFT.jpeg"),
      footerLink: []
    },
    {
      title: "AIR of 9203 in JEE Mains 2019",
      subtitle:
        "Scored 99.2 percentile in JEE mains 2019. Achieved an All India Rank of 9203 among 1.4 million candidates which appeared in the examination. JEE Main is entrance examination conducted by National Testing Agency for students aspiring to pursue undergraduate courses in top engineering institutes in India.",
      image: require("./assets/images/JeeMains.jpg"),
      footerLink: []
    },
    {
      title: "99.4 percentile in MHT CET 2019",
      subtitle:
        "Scored 99.4 percentile in MHT CET 2019. MHT CET (or Maharashtra Common Entrance Test) is a common state level entrance exam conducted by the State Common Entrance Test Cell, Government of Maharashtra every year for admission to undergraduate engineering, pharmacy and agriculture courses such as B.Tech/ B.E, Pharma D and B.Pharma offered at colleges in Maharashtra.",
      image: require("./assets/images/MHTCET.jpg"),
      footerLink: []
    }

    // {
    //   title: "Google Code-In Finalist",
    //   subtitle:
    //     "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
    //   image: require("./assets/images/codeInLogo.webp"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url:
    //         "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
    //     },
    //     {
    //       name: "Award Letter",
    //       url:
    //         "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
    //     },
    //     {
    //       name: "Google Code-in Blog",
    //       url:
    //         "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
    //     }
    //   ]
    // },
    // {
    //   title: "Google Assistant Action",
    //   subtitle:
    //     "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
    //   image: require("./assets/images/googleAssistantLogo.webp"),
    //   footerLink: [
    //     {
    //       name: "View Google Assistant Action",
    //       url:
    //         "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
    //     }
    //   ]
    // },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9307587237",
  email_address: "mohdrizwan.shaikh2112@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
